import useTypedFlags from "hooks/useTypedFlags";

const useRunObservabilityEnabled = () => {
  const { runObservabilityTab } = useTypedFlags();

  return runObservabilityTab;
};

export default useRunObservabilityEnabled;
